module.exports = __webpack_public_path__ + "img/img7.cb5a4d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/05/img7.png
// module id = 246
// module chunks = 0